import {Injectable} from '@angular/core';
import {UserSummary} from '../../../api/entity/userSummary.model';
import {User} from '../../../api/entity/user.model';
import {UserDataService} from './userData.service';
import {UserSummaryConverter} from '../../../api/converter/userSummary.converter';
import {
    AbstractDataServiceDtoSummaryAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';


@Injectable({providedIn: 'root'})
export class UserSummaryDataServiceAdapter extends
    AbstractDataServiceDtoSummaryAdapter<UserSummary, UserSummaryConverter, User> {
    constructor(dataService: UserDataService, converter: UserSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): User {
        return new User();
    }
}
